import { useRole } from '../../../common/hooks/useRole';

export interface MfaAccessControl {
    canViewMfa: boolean;
    canAddMfa: boolean;
    canDeleteMfa: boolean;
    canViewUserAuthenticationMethods: boolean;
    canViewBackupCodes: boolean;
    isSuperAdminViewingOthers: boolean;
    isAnyAdminViewingOthers: boolean;
}

export const useMfaAccessControl = (userId: string): MfaAccessControl => {
    const role = useRole();

    // Basic role checks
    const isSuperAdmin = role.isSuperAdmin();
    const isGroupAdmin = role.hasAdminRights() && !isSuperAdmin;
    const isOwnProfile = role.user.id === userId;

    // Determine access permissions
    const canViewMfa = role.user.id === userId || role.isSuperAdmin() || role.hasAdminRights();
    const canAddMfa = isOwnProfile;
    const canDeleteMfa = isOwnProfile || (isSuperAdmin && !isOwnProfile);
    const canViewUserAuthenticationMethods = isSuperAdmin || isGroupAdmin;
    const canViewBackupCodes = isOwnProfile;

    const isSuperAdminViewingOthers = isSuperAdmin && !isOwnProfile;
    const isAnyAdminViewingOthers = (isSuperAdmin || isGroupAdmin) && !isOwnProfile;

    return {
        canViewMfa,
        canAddMfa,
        canDeleteMfa,
        canViewUserAuthenticationMethods,
        canViewBackupCodes,
        isSuperAdminViewingOthers,
        isAnyAdminViewingOthers,
    };
};
